<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span><b>Finnegan’s Week</b></span></p>
<p class="authorname"><span>Joseph Wambaugh</span></p>
<p class="publisher"><img alt="logo" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b87ff94a